import { WebClient } from "@cisco/spaces-dash-lib-web";

const DOMAIN = "";
const API_PREFIX = "/api/v1";
const STATUS_CALL = "/user/current/status";
const LICENSE_TYPE_URL = "/location2/license/";
const LICENSE_USAGE = "/location2/license/globalUsageV2";
const MAP_DETAILS = "/location2/maps/details";
const RECENT_SEARCH = "/location2/recentSearch";
const UNCATEGORIZED_AP_COUNT = "/location2/wlc/uncategorized/apsCount";
const NETWORK_DEVICE_COUNT = "/location2/:locationId/countInfo";
const AP_LIST = "/location2/:locationId/accesspoints";
const CAMERAS_LIST = "/location2/camera/:locationId?";
const SENSORS_LIST = "/location2/sensorDetails/:locationId/:type?";
const SWITCH_LIST = "/location2/switch/:locationId?";
const WEBEX_DEVICES_LIST = "/location2/webexdevices/:locationId?";
const SP_DEVICES_LIST = "/location2/securityAppliance/:locationId";
const TENANT_LOCATION_METADATA = "/location2/getTenantLocationMetadata/:locationId";
const GET_METADATA = "/location/getMetaData/:locationId";
const ADD_LOC_METADATA = "/location2/addLocationMetadata/:locationId";
const MODIFY_LOC_METADATA = "/location2/modifyLocationMetadata/:locationId";
const DELETE_LOC_METADATA = "/location2/deleteLocationMetadata/:locationId";
const LIST_AP_PREFIX = "/location/wlc/ap/prefixes";
const LIST_AP_PREFIX_SEARCH = "/location/wlc/aps";
const UPDATE_AP_PREFIX = "/location/update";
const GET_LOCATION2_SYNC_STATUS = "/locationsync/status/:locationId";
const AUTO_PREFIX_STATUS = "/location/wlc/:locationId";
const UPDATE_LOCATION_INFO = "/location2/updateLocationInfo";
const SEARCH_CAMERAS = "/location2/search/camera";
const GET_WLC_CONTROLLERS = "/location2/wlc";
const RENAME_LOC2_URL = "/location2/rename/:locationId";
const DELETE_LOC2_URL = "/location/delete/:locationId";
const DELETE_LOC2_STATUS_URL = "/location/deleteStatus/:locationId";
const DELETE_CONTROLLER = "/location2/wlc/deleteController";
const UPDATE_CONTROLLER = "/location2/update";
const LIST_AVAILABLE_WLC_CONTROLLER = "/location2/wlc/controllerips";
const AVAILABLE_APS = "/location2/getAvailableAps";
const GET_IMAGE_AS_BYTE = "/map/getByteImage";
const GET_FLOOR_IMAGE = "/location2/maps/image";
const GET_FLOOR_DETAILS = "/location2/maps/floor/:locationId";
const UPDATE_POLYGON_ZONE = "/location2/maps/zone/update/:zoneId";
const CREATE_POLYGON_ZONE = "/location2/maps/zone/create/:floorId";
const CREATE_LH2_GROUP = "/location2/create";
const EDIT_AP_ZONE_CREATE_LOCATION = "/location2/create";
const GET_RULE_COUNT = "/rule/count";
const GET_RULES = "/rule/list";
const GET_DENSITY_RULES = "/rule/density/list";
const GET_HOME_PROPERTIES = "/home/client/config";
const GET_LICENSE_LIST_API = "/home/license/list";

const OPTIONS = {
  credentials: "include",
  mode: "cors",
  cache: "no-cache",
  redirect: "follow",
  referrerPolicy: "no-referrer",
  headers: {
    Accept: "application/json"
  }
};

export const userStatus = () => {
  return WebClient.get(`${API_PREFIX}${STATUS_CALL}`, OPTIONS);
};

export const getLicenseType = (locationId) => {
  return WebClient.get(`${DOMAIN}${API_PREFIX}${LICENSE_TYPE_URL}${locationId}`, OPTIONS);
};

export const getLicenseGlobalUsage = () => {
  return WebClient.get(`${DOMAIN}${API_PREFIX}${LICENSE_USAGE}`, OPTIONS);
};

export const recentSearch = () => {
  return WebClient.get(`${DOMAIN}${API_PREFIX}${RECENT_SEARCH}`, OPTIONS);
};

export const getMapDetails = (locationArray) => {
  return WebClient.post(`${DOMAIN}${API_PREFIX}${MAP_DETAILS}`, OPTIONS, locationArray);
};

export const unCategorisedApCount = (payload) => {
  return WebClient.post(`${DOMAIN}${API_PREFIX}${UNCATEGORIZED_AP_COUNT}`, OPTIONS, payload);
};

export const locationNetworkDeviceCount = (locationId, rootHasChildren) => {
  let url = `${DOMAIN}${API_PREFIX}${NETWORK_DEVICE_COUNT.replace(":locationId", locationId)}`;
  if (!rootHasChildren) {
    url += "?rootHasChildren=false";
  }
  return WebClient.get(url, OPTIONS);
};

export const getLocationApList = (locationId, start, end) => {
  const url = `${DOMAIN}${API_PREFIX}${AP_LIST.replace(":locationId", locationId)}?start=${start}&end=${end}`;
  return WebClient.get(url, OPTIONS);
};

export const searchAps = (locationId, searchText) => {
  const url = `${DOMAIN}${API_PREFIX}${AP_LIST.replace(":locationId", locationId)}?start=0&end=0&search=${searchText}`;
  return WebClient.get(url, OPTIONS);
};

export const searchCameras = (locationId, searchText) => {
  const url = `${DOMAIN}${API_PREFIX}${SEARCH_CAMERAS}?locationId=${locationId}&search=${searchText}`;
  return WebClient.get(url, OPTIONS);
};

export const getLocationCameraList = (locationId, start, end) => {
  const url = `${DOMAIN}${API_PREFIX}${CAMERAS_LIST.replace(":locationId", locationId)}start=${start}&end=${end}`;
  return WebClient.get(url, OPTIONS);
};

export const getSensorsList = (locationId, type, start, end, search) => {
  const url = `${DOMAIN}${API_PREFIX}${SENSORS_LIST.replace(":locationId", locationId).replace(":type", type)}start=${start}&end=${end}&search=${search}`;
  return WebClient.get(url, OPTIONS);
};

export const getSwitchList = (locationId, start, end) => {
  const url = `${DOMAIN}${API_PREFIX}${SWITCH_LIST.replace(":locationId", locationId)}start=${start}&end=${end}`;
  return WebClient.get(url, OPTIONS);
};

export const getWebexDevicesList = (locationId) => {
  const url = `${DOMAIN}${API_PREFIX}${WEBEX_DEVICES_LIST.replace(":locationId", locationId)}`;
  return WebClient.get(url, OPTIONS);
};

export const getSpDevicesList = (locationId) => {
  const url = `${DOMAIN}${API_PREFIX}${SP_DEVICES_LIST.replace(":locationId", locationId)}`;
  return WebClient.get(url, OPTIONS);
};

export const getTenantLocationMetadata = (locationId) => {
  const url = `${DOMAIN}${API_PREFIX}${TENANT_LOCATION_METADATA.replace(":locationId", locationId)}`;
  return WebClient.get(url, OPTIONS);
};

export const getMetadataListLh2 = (locationId) => {
  const url = `${DOMAIN}${API_PREFIX}${GET_METADATA.replace(":locationId", locationId)}`;
  return WebClient.get(url, OPTIONS);
};

export const saveLocationMetadataLh2 = (locationId, payload) => {
  const url = `${API_PREFIX}${ADD_LOC_METADATA.replace(":locationId", locationId)}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const editLocationMetadataLh2 = (locationId, payload) => {
  const url = `${API_PREFIX}${MODIFY_LOC_METADATA.replace(":locationId", locationId)}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const deleteLocationMetadataLh2 = (locationId, payload) => {
  const url = `${API_PREFIX}${DELETE_LOC_METADATA.replace(":locationId", locationId)}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const listApPrefix = (payload) => {
  const url = `${DOMAIN}${API_PREFIX}${LIST_AP_PREFIX}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const searchMatchingApPrefix = (payload) => {
  const url = `${DOMAIN}${API_PREFIX}${LIST_AP_PREFIX_SEARCH}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const updateApPrefix = (payload) => {
  const url = `${DOMAIN}${API_PREFIX}${UPDATE_AP_PREFIX}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const getLocation2SyncStatus = (locationId) => {
  const url = `${DOMAIN}${API_PREFIX}${GET_LOCATION2_SYNC_STATUS.replace(":locationId", locationId)}`;
  return WebClient.get(url, OPTIONS);
};

export const autoPrefixStatus = (locationId) => {
  const url = `${DOMAIN}${API_PREFIX}${AUTO_PREFIX_STATUS.replace(":locationId", locationId)}`;
  return WebClient.get(url, OPTIONS);
};

export const updateLocationInfo = (payload) => {
  const url = `${DOMAIN}${API_PREFIX}${UPDATE_LOCATION_INFO}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const getWLCControllers = (locationId) => {
  return WebClient.get(`${DOMAIN}${API_PREFIX}${GET_WLC_CONTROLLERS}/${locationId}`, OPTIONS);
};

export const getFloorImageFromS3 = (imageObj) => {
  const url = `${DOMAIN}${API_PREFIX}${GET_IMAGE_AS_BYTE}`;
  return WebClient.post(url, OPTIONS, imageObj);
};

export const getFloorDetails = (locationId) => {
  const url = `${DOMAIN}${API_PREFIX}${GET_FLOOR_DETAILS.replace(":locationId", locationId)}`;
  return WebClient.get(url, OPTIONS);
};

export const getFloorMapImage = (imageObj) => {
  const url = `${DOMAIN}${API_PREFIX}${GET_FLOOR_IMAGE}`;
  return WebClient.post(url, OPTIONS, imageObj);
};

export const renameLoc2 = (locationId, payload) => {
  const url = `${API_PREFIX}/${RENAME_LOC2_URL.replace(":locationId", locationId)}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const deleteLocationLh2 = (locationId) => {
  return WebClient.delete(`${API_PREFIX}/${DELETE_LOC2_URL.replace(":locationId", locationId)}`, OPTIONS);
};

export const getDeleteLocationStatus = (locationId) => {
  return WebClient.get(`${API_PREFIX}${DELETE_LOC2_STATUS_URL.replace(":locationId", locationId)}`, OPTIONS);
};

export const deleteController = (payload) => {
  const url = `${DOMAIN}${API_PREFIX}${DELETE_CONTROLLER}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const updateController = (payload) => {
  const url = `${DOMAIN}${API_PREFIX}${UPDATE_CONTROLLER}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const getAvailableWLCControllers = (wlcType) => {
  return WebClient.get(`${DOMAIN}${API_PREFIX}${LIST_AVAILABLE_WLC_CONTROLLER}/${wlcType}`, OPTIONS);
};

export const getAvailableAPs = (locationId) => {
  return WebClient.get(`${DOMAIN}${API_PREFIX}${AVAILABLE_APS}/${locationId}`, OPTIONS);
};

export const updatePolygonZone = (zonePayload, zoneId) => {
  const url = `${DOMAIN}${API_PREFIX}${UPDATE_POLYGON_ZONE.replace(":zoneId", zoneId)}`;
  return WebClient.put(url, OPTIONS, zonePayload);
};

export const createPolygonZone = (zonePayload, floorId) => {
  const url = `${DOMAIN}${API_PREFIX}${CREATE_POLYGON_ZONE.replace(":floorId", floorId)}`;
  return WebClient.post(url, OPTIONS, zonePayload);
};

export const createGroupLh2 = (payload) => {
  const url = `${API_PREFIX}${CREATE_LH2_GROUP}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const editApZoneCreateLocation = (payload) => {
  const url = `${DOMAIN}${API_PREFIX}${EDIT_AP_ZONE_CREATE_LOCATION}`;
  const options = OPTIONS;
  options.responseType = "text";
  return WebClient.postWithOption(url, options, payload);
};

export const fetchRules = (locationId, type) => {
  const payload = {
    locationId: locationId.toString(),
    ruleType: type
  };
  const url = `${API_PREFIX}${type === "Density" ? GET_DENSITY_RULES : GET_RULES}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const fetchRulesCount = (locationId) => {
  const payload = {
    locationId: locationId.toString()
  };
  const url = `${API_PREFIX}${GET_RULE_COUNT}`;
  return WebClient.post(url, OPTIONS, payload);
};

export const getHomeProperties = () => {
  const url = `${API_PREFIX}${GET_HOME_PROPERTIES}`;
  return WebClient.get(url, OPTIONS);
};

export const getLicensesList = () => {
  const url = `${API_PREFIX}${GET_LICENSE_LIST_API}`;
  return WebClient.get(url, OPTIONS);
};
